import { graphql, useStaticQuery } from 'gatsby';

export const useBankHolidays = () => {
  const { bankHolidayDates } = useStaticQuery(graphql`
    query bankHolidayDatesQuery {
      bankHolidayDates {
        england_and_wales {
          events {
            date
          }
        }
        scotland {
          events {
            date
          }
        }
      }
    }
  `);
  return bankHolidayDates;
};
